const PortfolioS1 = () => {
  return (
    <div className="portfolio_s1">
      <div className="text_box">
        <p>PORTFOLIO</p>
        <p id="pc">
          폰드 하우스는 대구/경북을 중심으로 웨딩 애프터무비를 제작합니다.
          <br />
          다양한 경험을 통해 만들어진 실력으로 기록하겠습니다.
        </p>
        <p id="mobile">
          폰드 하우스는 대구/경북을 중심으로
          <br />
          웨딩 애프터무비를 제작합니다.
          <br />
          다양한 경험을 통해 만들어진
          <br /> 실력으로 기록하겠습니다.
        </p>
      </div>
    </div>
  );
};

export default PortfolioS1;
